import { render, staticRenderFns } from "./GroupAvatar.vue?vue&type=template&id=aa5c9f86&"
import script from "./GroupAvatar.vue?vue&type=script&lang=js&"
export * from "./GroupAvatar.vue?vue&type=script&lang=js&"
import style0 from "./GroupAvatar.vue?vue&type=style&index=0&id=aa5c9f86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports